import { formatClock } from '../../shared/format';
import type { AuthorSeat, PublicRound } from '../../shared/types';

/**
 * One side of the SchachUhr. 1-second display resolution (F-8); the active
 * side is inverted ink-on-color, a frozen side shows AUS.
 */
export function Clock(props: {
  seat: AuthorSeat | undefined;
  seatIndex: number;
  round: PublicRound;
  remainingMs: number;
  size?: 'S' | 'M' | 'L';
  className?: string;
}) {
  const { seat, seatIndex, round, remainingMs, size = 'M', className } = props;
  const isActive = round.phase === 'running' && round.activeAuthor === seatIndex;
  const isFrozen = round.frozen[seatIndex] === true;
  const color = seat?.color ?? '#111';
  return (
    <div
      className={`clock clock--${size} ${isActive ? 'clock--active' : ''} ${isFrozen ? 'clock--frozen' : ''} ${
        className ?? ''
      }`}
      style={isActive ? { background: color } : { borderColor: color }}
      data-testid={`clock-${seatIndex}`}
    >
      <div className="clock__name">
        <span className="clock__dot" style={{ background: isActive ? '#fff' : color }} />
        {seat ? seat.name : `Autor:in ${seatIndex + 1}`}
        {seat && !seat.connected && <span className="clock__offline"> · offline</span>}
      </div>
      <div className="clock__time" data-testid={`clock-time-${seatIndex}`}>
        {formatClock(remainingMs)}
      </div>
      <div className="clock__status">
        {isFrozen ? 'ZEIT AUS' : isActive ? 'SCHREIBT' : round.confirmedDone[seatIndex] ? 'FERTIG ✓' : ' '}
      </div>
    </div>
  );
}
